/**
 * CITY HOP — cartridge palette.
 *
 * Top-down '84 city street aesthetic. Distinct from the racing cartridges:
 * cooler asphalt grey grounds the playfield, sidewalk concrete provides
 * the safe-zone visual rhythm, neon-yellow player reads against everything,
 * and varied car colors (taxi yellow, fire red, bus blue, civilian beige)
 * keep traffic readable at a glance.
 */

// Sidewalk (safe zones).
export const SIDEWALK_LIGHT = '#9a9aa8';
export const SIDEWALK_DARK = '#6a6a78';
export const SIDEWALK_LINE = '#3a3a48';
export const SIDEWALK_DIAGONAL = '#7a7a88'; // diagonal corner tile fill

// Road.
export const ROAD_DARK = '#1a1a24';
export const ROAD_LIGHT = '#22222e';
export const ROAD_LINE = '#e8e8f0';
export const ROAD_EDGE = '#3a3a48';

// Player — neon-yellow figure, reads against asphalt + concrete both.
export const PLAYER_BODY = '#ffea00';
export const PLAYER_HEAD = '#ffcc00';
export const PLAYER_LIMB = '#a08a00';
export const PLAYER_HIT = '#ff3030'; // briefly flashed on collision

// Cars. Mix of bright + muted so traffic reads at a glance.
export const CAR_TAXI = '#ffaa00';
export const CAR_TAXI_DARK = '#a06800';
export const CAR_BUS = '#3a7aba';
export const CAR_BUS_DARK = '#1a4070';
export const CAR_FIRE = '#d83030';
export const CAR_FIRE_DARK = '#801818';
export const CAR_CIVILIAN = '#b0a890';
export const CAR_CIVILIAN_DARK = '#605a40';
export const CAR_VAN = '#5a5a6a';
export const CAR_VAN_DARK = '#2a2a3a';
export const CAR_WINDOW = '#1a3a55';
export const CAR_HEADLIGHT = '#ffea00';

// HUD.
export const HUD_TEXT = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_LEVEL = '#00d9ff';
export const HUD_LIVES = '#ff8a00';

// Effects.
export const CRASH_FLASH = '#ff3030';
export const LEVEL_UP_FLASH = '#7af3c8';

/** Tokens the cabinet samples for marquee tinting while this cartridge is loaded. */
export const PALETTE_HINT: readonly string[] = [
  PLAYER_BODY,
  CAR_TAXI,
  CAR_BUS,
  CRASH_FLASH,
];
